<template>
  <ul v-if="showPop && items.length>0" class="menu-box"  @mousedown.stop="mouseDown"  oncontextmenu='return false' :style="freeStyle">
    <slot name="above"></slot>
    <li v-for="(item,it) in items" @click="listItemClick(it,item)">
      <a><i :class="item.class || item.icon"></i><span class="menu-boxmenu-sep">&nbsp;</span><span>{{item.txt || item.text}}</span></a>
    </li>
    <slot name="below"></slot>
  </ul>
</template>

<script>
  export default{
    name:'rightMenu',
    props: [
      'popItems', 'mouse', 'zIndex', 'width', 'height', 'border','padding',
      'boxShadow','background','borderRadius','color'
    ],
    data(){
      return {
        freeStyle:'',
        showPop:false
      }
    },
    watch: {
      mouse() {
        let self = this;
        let x = self.mouse[0];
        let y = self.mouse[1];
        this.updateMenu(x, y)
      }
    },
    computed:{
      items(){
        return this.popItems
      }
    },
    created(){
      //document.oncontextmenu = preventExplorerMenu;
    },
    beforeDestroy(){
      //document.oncontextmenu = true;
    },
    methods: {
      listItemClick(it,item){
        let self = this;
        self.$emit('ListItemClick',it,item);
      },
      mouseDown() {

      },
      close() {
        this.showPop=false;
      },
      show(x, y) {
        this.updateMenu(x,y);
      },
      updateMenu(x,y){
        let self=this;
        if(x === 'close'){
          self.showPop = false
        }
        else {
          self.freeStyle = `left:${x}px; top:${y}px;width:${self.width};` +                  //计算鼠标位置
            `z-index:${self.zIndex};
                            height:${self.height};
                            border:${self.border}; padding: ${self.padding};
                            box-shadow:${self.boxShadow}; background: ${self.background};
                            border-radius:${self.borderRadius}; color: ${self.color}
                           `;
          self.showPop = true
        }
      }
    },
    mounted(){

    }
  }

  function preventExplorerMenu(){
    return false
  }
</script>

<style scoped>
  .menu-box {
   width:125px
  }
  .menu-box,
  .menu-box ul {
    margin: 0;
    padding: 2px;
    position: absolute;
    z-index:10000;
    background: #f5f5f5;
    border: 1px solid #979797;
    box-shadow: 2px 2px 2px #999999;
  }
  .menu-box ul {
    list-style: none;
    left: 100%;
    margin-top: -2.7em;
    margin-left: -4px;
  }
  .menu-box .menu-box-right ul {
    left: auto;
    right: 100%;
    margin-left: auto;
    margin-right: -4px;
  }
  .menu-box li {
    list-style: none;
  }
  .menu-box li > a {
    display: block;
    padding: 0 2em 0 2em;
    text-decoration: none;
    width: auto;
    color: black;
    white-space: nowrap;
    line-height: 2.4em;
    text-shadow: 1px 1px 0 white;
    border-radius: 1px;
  }
  .menu-box li > a:hover {
    position: relative;
    background-color: #e8eff7;
    box-shadow: 0 0 2px #0a6aa1;
  }
  .menu-box li > a.menu-box-parent {
    background-image: url("data:image/gif;base64,R0lGODlhCwAHAIAAACgoKP///yH5BAEAAAEALAAAAAALAAcAAAIORI4JlrqN1oMSnmmZDQUAOw==");
    background-position: right center;
    background-repeat: no-repeat;
  }
  .menu-box li > a:focus {
    outline: 0;
  }
  .menu-box .menu-box-hover > a {
    position: relative;
    background-color: #e8eff7;
    box-shadow: 0 0 2px #0a6aa1;
  }
  .menu-box .menu-box-separator > a,
  .menu-box .menu-box-separator > a:hover {
    background: white;
    border: 0;
    border-top: 1px solid #e2e3e3;
    height: 1px;
    min-height: 1px;
    max-height: 1px;
    padding: 0;
    margin: 0 0 0 2.4em;
    border-left: 1px solid #e0e0e0;
    text-shadow: 0 0 0 transparent;
    box-shadow: 0 0 0 transparent;
    border-radius: 0;
  }
  .menu-box .menu-boxmenu-disabled a,
  .menu-box .menu-boxmenu-disabled a:hover {
    color: silver;
    background-color: transparent;
    border: 0;
    box-shadow: 0 0 0;
  }
  .menu-box li > a > i {
    text-decoration: none;
    display: inline-block;
    width: 2.4em;
    height: 2.4em;
    background: transparent;
    margin: 0 0 0 -2em;
    vertical-align: top;
    text-align: center;
    line-height: 2.4em;
  }
  .menu-box li > a > i:empty {
    width: 2.4em;
    line-height: 2.4em;
  }
  .menu-box li > a .menu-boxmenu-sep {
    display: inline-block;
    width: 1px;
    height: 2.4em;
    background: white;
    margin: 0 0.5em 0 0;
    border-left: 1px solid #e2e3e3;
  }
  .menu-box .menu-boxmenu-shortcut {
    font-size: 0.8em;
    color: silver;
    opacity: 0.5;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/right-menu/index.vue